var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113483_239167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9904 0.00977428C8.05511 0.0118824 0.0026843 8.06775 0.00479243 18.003C0.00549514 21.4433 0.992733 24.8111 2.84929 27.7074L0.0504686 34.9692C-0.0985762 35.3554 0.0936853 35.7893 0.479895 35.9383C0.566258 35.9716 0.657962 35.9887 0.750508 35.9886C0.83638 35.989 0.921618 35.9743 1.00236 35.9451L8.49796 33.2692C16.9313 38.5216 28.0259 35.9428 33.2782 27.5094C38.5305 19.076 35.9519 7.98152 27.5184 2.72919C24.6597 0.948665 21.3584 0.00647154 17.9904 0.00977428Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5667 21.0732C26.5667 21.0732 24.7304 20.1738 23.5805 19.5741C22.2793 18.904 20.7502 20.1588 20.0306 20.8724C18.9107 20.4422 17.8879 19.7929 17.0219 18.9625C16.1914 18.0967 15.5421 17.0738 15.112 15.9538C15.8256 15.2327 17.0774 13.7051 16.4103 12.4039C15.8181 11.2526 14.9112 9.41766 14.9112 9.41619C14.7839 9.16363 14.5254 9.00419 14.2426 9.00391H12.7435C10.5603 9.38098 8.97296 11.2859 8.99573 13.5012C8.99573 15.8548 11.8125 20.3762 13.712 22.277C15.6114 24.1779 20.1327 26.9933 22.4877 26.9933C24.7031 27.016 26.608 25.4286 26.9851 23.2455V21.7464C26.9853 21.4606 26.8231 21.1995 26.5667 21.0732Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113483_239167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.d733aba8443d1bddcdb727dad259c5e9.svg";
export { ForwardRef as ReactComponent };